module.exports = __webpack_public_path__ + "img/male-youngadult-foot.e00d6400.svg";